var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var ApiService = /** @class */ (function () {
    function ApiService(urlPrefix, errorCallback) {
        this.urlPrefix = urlPrefix;
        this.errorCallback = errorCallback || null;
    }
    ApiService.prototype.makeRequest = function (url, options, requestSettings) {
        return __awaiter(this, void 0, void 0, function () {
            var requestURL, requestBody, res, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        requestURL = this.buildURL(url, options.params, (requestSettings === null || requestSettings === void 0 ? void 0 : requestSettings.isUsedCommaToSeparateQueryParamsValues) || false);
                        requestBody = options.body
                            ? JSON.stringify(options.body)
                            : undefined;
                        return [4 /*yield*/, fetch(requestURL, __assign({ method: options.method, headers: this.buildHeaders(options.headers), body: requestBody, credentials: 'include' }, (options.signal ? { signal: options.signal } : {})))];
                    case 1:
                        res = _a.sent();
                        if (!res.ok) {
                            return [2 /*return*/, this.processError(res)];
                        }
                        return [2 /*return*/, this.processResponse(res)];
                    case 2:
                        error_1 = _a.sent();
                        return [2 /*return*/, this.processError(error_1)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ApiService.prototype.makeRequestWithFormData = function (url, method, formData) {
        return __awaiter(this, void 0, void 0, function () {
            var res, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, fetch(this.buildURL(url), {
                                method: method,
                                credentials: 'include',
                                body: formData,
                            })];
                    case 1:
                        res = _a.sent();
                        if (!res.ok) {
                            return [2 /*return*/, this.processError(res)];
                        }
                        return [2 /*return*/, this.processResponse(res)];
                    case 2:
                        error_2 = _a.sent();
                        return [2 /*return*/, this.processError(error_2)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ApiService.prototype.buildQuery = function (params, isUsedCommaToSeparateQueryParamsValues) {
        if (!params) {
            return '';
        }
        if (isUsedCommaToSeparateQueryParamsValues) {
            // URLSearchParams argument type can't get hash with values as arrays
            // but work with it correctly
            var searchParams = new URLSearchParams(params);
            // Commas will be shielded
            return "?" + searchParams.toString();
        }
        return this.getQueryParamsWithDuplicateKeys(params);
    };
    ApiService.prototype.buildURL = function (url, params, isUsedCommaToSeparateQueryParamsValues) {
        var query = this.buildQuery(params, isUsedCommaToSeparateQueryParamsValues);
        return this.urlPrefix + "/" + url + query;
    };
    ApiService.prototype.getDefaultHeaders = function () {
        return new Headers({
            Accept: 'application/json',
            'Content-Type': 'application/json',
        });
    };
    ApiService.prototype.buildHeaders = function (headers) {
        if (headers === void 0) { headers = this.getDefaultHeaders(); }
        if (!headers.get('Content-Type')) {
            headers.append('Content-Type', 'application/json');
        }
        return headers;
    };
    ApiService.prototype.processResponse = function (response) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var result, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _d.trys.push([0, 5, , 6]);
                        if (!((_a = response.headers
                            .get('Content-Type')) === null || _a === void 0 ? void 0 : _a.includes('application/json'))) return [3 /*break*/, 2];
                        return [4 /*yield*/, response.json()];
                    case 1:
                        _b = _d.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, response.text()];
                    case 3:
                        _b = _d.sent();
                        _d.label = 4;
                    case 4:
                        result = _b;
                        return [2 /*return*/, {
                                success: true,
                                status: response.status,
                                data: result,
                            }];
                    case 5:
                        _c = _d.sent();
                        return [2 /*return*/, {
                                success: true,
                                status: response.status,
                            }];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    ApiService.prototype.processError = function (error) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var data, _c, parseError_1;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (this.errorCallback) {
                            this.errorCallback(error);
                        }
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 6, , 7]);
                        if (!((_b = (_a = error.headers) === null || _a === void 0 ? void 0 : _a.get('Content-Type')) === null || _b === void 0 ? void 0 : _b.includes('application/json'))) return [3 /*break*/, 3];
                        return [4 /*yield*/, error.json()];
                    case 2:
                        _c = _d.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, error.text()];
                    case 4:
                        _c = _d.sent();
                        _d.label = 5;
                    case 5:
                        data = _c;
                        return [2 /*return*/, Promise.resolve({
                                success: false,
                                status: error.status,
                                data: data,
                            })];
                    case 6:
                        parseError_1 = _d.sent();
                        return [2 /*return*/, Promise.resolve({
                                success: false,
                                status: error.status,
                            })];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    ApiService.prototype.getQueryParamsWithDuplicateKeys = function (params) {
        var items = [];
        Object.entries(params).forEach(function (_a) {
            var key = _a[0], value = _a[1];
            if (Array.isArray(value)) {
                value.forEach(function (valueItem) {
                    return items.push(encodeURIComponent(key) + "=" + encodeURIComponent(valueItem));
                });
            }
            else {
                items.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
            }
        });
        return "?" + items.join('&');
    };
    return ApiService;
}());
export { ApiService };
//# sourceMappingURL=ApiService.js.map